export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 DES FEUILLES JAUNES… ET UN APPORT DÉCIDÉ TROP VITE',
    body: 'Un jaunissement apparaît, un engrais est apporté, et le problème persiste. Le même symptôme peut venir d’une carence, d’un blocage dans le sol, d’une maladie ou d’un stress.',
  },
  {
    title: '🔍 CARENCE, MALADIE OU STRESS ?',
    body: 'Chlorose, nécrose, ponctuations, déformations : sans comparaison méthodique, on confond facilement les causes et on intervient sur la mauvaise piste.',
  },
  {
    title: '🧪 LE NUTRIMENT EST LÀ… MAIS LA PLANTE NE L’ABSORBE PAS',
    body: 'pH, CEC, salinité, compaction, interactions entre éléments : sans lire le sol, on ne comprend pas pourquoi la plante manque de ce qui est pourtant présent.',
  },
  {
    title: '📚 DES INFORMATIONS DISPERSÉES PARTOUT',
    body: 'Cours, notes, bulletins d’analyse, forums : l’information existe, mais jamais organisée au moment où vous êtes devant la parcelle.',
  },
]
